import React from 'react'
import {connect} from 'react-redux'

import approveModeratedMessage from '../data/setters/approve_moderated_message'
import disapproveModeratedMessage from '../data/setters/disapprove_moderated_message'

const MessageApprovalActions = (props) => {
  const ApproveBtn = (
    <button
      className='approval-action btn btn-sm btn-success'
      onClick={props.approveMessage}>
      <i className='rc-icon-check'/>
    </button>
  )

  const DisapproveBtn = (
    <button
      className='approval-action btn btn-sm btn-danger'
      onClick={props.disapproveMessage}>
      <i className='rc-icon-close'/>
    </button>
  )

  return (
    <div className='message-approval-actions'>
      {ApproveBtn}
      {DisapproveBtn}
    </div>
  )
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    approveMessage: () => approveModeratedMessage(ownProps.containerId, ownProps.messageId),
    disapproveMessage: () => disapproveModeratedMessage(ownProps.containerId, ownProps.messageId)
  }
}

const MessageApprovalActionsContainer = connect(
  null, mapDispatchToProps
)(MessageApprovalActions)

export default MessageApprovalActionsContainer



/** WEBPACK FOOTER **
 ** ./modules/shared/conversation/message_approval_actions.js
 **/